"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidOptions = void 0;

var _BasePluginError2 = require("./BasePluginError");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InvalidOptions =
/*#__PURE__*/
function (_BasePluginError) {
  _inherits(InvalidOptions, _BasePluginError);

  /* istanbul ignore next */
  function InvalidOptions() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _BasePluginError2.BasePluginError._MESSAGE_;

    _classCallCheck(this, InvalidOptions);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidOptions).call(this, message));
  }

  return InvalidOptions;
}(_BasePluginError2.BasePluginError);

exports.InvalidOptions = InvalidOptions;

_defineProperty(InvalidOptions, "_MESSAGE_", 'invalid plugin options');
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvRXhjZXB0aW9ucy9JbnZhbGlkT3B0aW9ucy50cyJdLCJuYW1lcyI6WyJJbnZhbGlkT3B0aW9ucyIsIm1lc3NhZ2UiLCJCYXNlUGx1Z2luRXJyb3IiLCJfTUVTU0FHRV8iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBRWFBLGM7Ozs7O0FBR1g7QUFDQSw0QkFBeUQ7QUFBQSxRQUE3Q0MsT0FBNkMsdUVBQTNCQyxrQ0FBZ0JDLFNBQVc7O0FBQUE7O0FBQUEsdUZBQ2pERixPQURpRDtBQUV4RDs7O0VBTmlDQyxpQzs7OztnQkFBdkJGLGMsZUFDbUMsd0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBCYXNlUGx1Z2luRXJyb3IgfSBmcm9tICcuL0Jhc2VQbHVnaW5FcnJvcidcclxuXHJcbmV4cG9ydCBjbGFzcyBJbnZhbGlkT3B0aW9ucyBleHRlbmRzIEJhc2VQbHVnaW5FcnJvciB7XHJcbiAgcHJvdGVjdGVkIHN0YXRpYyByZWFkb25seSBfTUVTU0FHRV86IHN0cmluZyA9ICdpbnZhbGlkIHBsdWdpbiBvcHRpb25zJ1xyXG5cclxuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xyXG4gIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZyA9IEJhc2VQbHVnaW5FcnJvci5fTUVTU0FHRV8pIHtcclxuICAgIHN1cGVyKG1lc3NhZ2UpXHJcbiAgfVxyXG59XHJcbiJdfQ==